import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-thumb-down',
  templateUrl: './thumb-down.component.html',
  styleUrls: ['./thumb-down.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThumbDownIconComponent {}
